export default __webpack_public_path__ + "static/media/breakup.e84d9fdb.png";